// extracted by mini-css-extract-plugin
export default {"movieList":"MovieListInfinite_movieList__Hi0o1"};